import React from 'react'

const PageHeader = ({ title, isMobile }) => {
  return (
    <div className="flex items-center justify-between">
      <h1 className="text-base md:text-lg font-semibold dark:text-customWhite text-customBlack">{title}</h1>
      <div className="flex items-center gap-3 dark:text-white/60 text-customBlack/60">
        {/* Top-right icons placeholder */}
        <button className="h-9 w-9 rounded-lg bg-white/5 hover:bg-white/10 transition-colors grid place-items-center" aria-label="Search">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
            <path fillRule="evenodd" d="M10.5 3a7.5 7.5 0 015.916 12.24l3.172 3.172a.75.75 0 11-1.06 1.06l-3.172-3.171A7.5 7.5 0 1110.5 3zm0 1.5a6 6 0 100 12 6 6 0 000-12z" clipRule="evenodd" />
          </svg>
        </button>
        <button className="h-9 w-9 rounded-lg bg-white/5 hover:bg-white/10 transition-colors grid place-items-center" aria-label="Notifications">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-5 w-5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75V9a6 6 0 10-12 0v.75a8.967 8.967 0 01-2.311 6.02c1.766.64 3.57 1.085 5.403 1.316m5.765 0a24.255 24.255 0 01-5.765 0m5.765 0a3 3 0 11-5.765 0" />
          </svg>
        </button>
      </div>
    </div>
  )
}

export default PageHeader

